var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudBlack24Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M10,5.5a4.492,4.492,0,0,1,4.492,3.323l.25,1.125,1.275.082a2.35,2.35,0,0,1,2.317,2.22,2.392,2.392,0,0,1-2.5,2.25H5a3.179,3.179,0,0,1-3.333-3A3.115,3.115,0,0,1,4.633,8.523l.892-.082.417-.713A4.641,4.641,0,0,1,10,5.5M10,4A6.36,6.36,0,0,0,4.458,7.03,4.7,4.7,0,0,0,0,11.5,4.774,4.774,0,0,0,5,16H15.833A3.976,3.976,0,0,0,20,12.25a3.924,3.924,0,0,0-3.875-3.72A6.111,6.111,0,0,0,10,4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBlack24Dp);
export default __webpack_public_path__ + "static/media/cloud_black_24dp.1ef37be89a445d0c5ed2997a8769510a.svg";
export { ForwardRef as ReactComponent };